import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import { environment } from 'src/environments/environment';
import {lastValueFrom, Observable} from "rxjs";
import {SaqueCopiaColaModel} from "./saque-copia-cola.model";

@Injectable({
  providedIn: 'root'
})
export class SaqueCopiaColaService {
  constructor(private http: HttpClient)
  {
  }

  sendWithdraw(request : SaqueCopiaColaModel) : Observable<any>
  {
    return this.http.post<any>(`${environment.apiUrl}/withdraw`, request);
  }

}

